// extracted by mini-css-extract-plugin
export var activeFilterButton = "_na-c";
export var backButton = "_na-4";
export var backIcon = "_na-5";
export var chevronShortcut = "_na-6";
export var container = "_na-1";
export var editor = "_na-8";
export var editorWrapper = "_na-7";
export var prefix = "_na-2";
export var searchIcon = "_na-3";
export var suffix = "_na-9";
export var suffixContent = "_na-a";
export var suffixText = "_na-b";
export var wrapper = "_na-0";